var React = require('react');

function RetailIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M91 89v-3h-7V49h4v-4l-4-12h-5v-5H64v-6H36v6H21v5h-5l-4 12v4h4v37H9v3H5v6h90v-6h-4zM70 37h5v8h-5v-8zm-9 0h5v8h-5v-8zm-9 0h5v8h-5v-8zm-27 0h5v8h-5v-8zm-6.1 0H21v8h-4.8l2.7-8zM39 86H21V55h18v31zm0-41h-5v-8h5v8zm4-8h5v8h-5v-8zm36 38H44V55h35v20zm0-30v-8h2.1l2.7 8H79z","key":0}),React.createElement("path",{"d":"M32 69h5v2h-5z","key":1})]);
}

RetailIcon.defaultProps = {"className":"retail-icon","viewBox":"0 8 100 97"};

module.exports = RetailIcon;

RetailIcon.default = RetailIcon;
